import {getActionData} from "_helpers";
import {alertMessages, organizationSettingsConstants, scheduleConstants} from "_constants";
import {organizationSettingsService} from "_services";
import {SnackBar} from "../components/common";
import {Auth} from "../components/Authorization";
import _ from "lodash";
import {handleNoResultMessage} from "./utility.action";

function getOrganizationInfo(id) {
    return dispatch => {
        dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_INFO_REQUEST));
        organizationSettingsService.getOrganizationInfo(id)
            .then((response) => {
                dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_INFO_SUCCESS, response.data));
            }).catch((error) => {
            if (_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_INFO_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        });
    }
}

function deleteSchedule(params) {
    return dispatch => {
        dispatch(getActionData(scheduleConstants.DELETE_REQUEST));
        organizationSettingsService.deleteSchedule(params)
            .then((response) => {
                dispatch(getActionData(scheduleConstants.DELETE_SUCCESS));
                dispatch(organizationSettingsActions.removeScheduleFromStore(params.id, params.handleName))
            }).catch((error) => {
            if (_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(scheduleConstants.DELETE_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        });
    }
}

function removeScheduleFromStore(id, handleName){
    return(dispatch) =>{
        dispatch(getActionData(scheduleConstants.REMOVE_SCHEDULE_FROM_STORE, {id, handleName}))
    }
}

function getOrganizationCSMs(id) {
    return dispatch => {
        dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_CSM_LIST_REQUEST));
        organizationSettingsService.getOrganizationCSMs(id)
            .then((response) => {
                dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_CSM_LIST_SUCCESS, response.data));
            }).catch((error) => {
            if (_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_CSM_LIST_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        });
    }
}

function updateOrganizationAttribute(organizationId, payload, actionType = null) {
    return dispatch => {
        dispatch(getActionData(organizationSettingsConstants.UPDATE_ORGANIZATION_ATTRIBUTE_REQUEST, {actionType, payload}));
        organizationSettingsService.updateOrganizationAttribute(organizationId, payload)
            .then((response) => {
                dispatch(getActionData(organizationSettingsConstants.UPDATE_ORGANIZATION_ATTRIBUTE_SUCCESS, response.data));
                SnackBar.showMessage(alertMessages.ORGANIZATION_ATTRIBUTE_UPDATE_SUCCESS);
            }).catch((error) => {
            if (_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(organizationSettingsConstants.UPDATE_ORGANIZATION_ATTRIBUTE_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.ORGANIZATION_ATTRIBUTE_UPDATE_FAILURE);
        });
    }
}

function updateTicketBudget(organizationId, payload) {
    return dispatch => {
        dispatch(getActionData(organizationSettingsConstants.UPDATE_TICKET_BUDGET_REQUEST, payload));
        organizationSettingsService.updateTicketBudget(organizationId, payload)
            .then((response) => {
                dispatch(getActionData(organizationSettingsConstants.UPDATE_TICKET_BUDGET_SUCCESS, response.data));
                SnackBar.showMessage(alertMessages.TICKET_BUDGET_UPDATE_SUCCESS);
            }).catch((error) => {
            if (_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(organizationSettingsConstants.UPDATE_TICKET_BUDGET_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.TICKET_BUDGET_UPDATE_FAILURE);
        });
    }
}

function getMsgDataSources(organizationId) {
    return dispatch => {
        dispatch(getActionData(organizationSettingsConstants.GET_MSG_DATA_SOURCES_REQUEST));
        organizationSettingsService.getOrgMsgDataSourcesGroupedByMsgSource(organizationId)
            .then((response) => {
                dispatch(getActionData(organizationSettingsConstants.GET_MSG_DATA_SOURCES_SUCCESS, response.data));
            }).catch((error) => {
            if (_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(organizationSettingsConstants.GET_MSG_DATA_SOURCES_FAILURE, {}, error));
            handleNoResultMessage(error);
        });
    }
}

function dataSourceHandleInfoResponseWithOrganizationId(responseData, organizationId) {
    const itemsWithOrganizationId = responseData.items.map((item) => _.merge(item, { organizationId }));
    return _.merge(responseData, { items: itemsWithOrganizationId });
}

function getDataSourceHandleInfo(organizationId, requestType) {
    return dispatch => {
        dispatch(getActionData(requestType));
        organizationSettingsService.getDataSourceHandleInfo(organizationId)
            .then((response) => {
                const data = dataSourceHandleInfoResponseWithOrganizationId(response.data, organizationId);
                dispatch(getActionData(organizationSettingsConstants.GET_DATA_SOURCE_HANDLE_INFO_SUCCESS, data));
            }).catch((error) => {
            if (_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(organizationSettingsConstants.GET_DATA_SOURCE_HANDLE_INFO_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        });
    };
}

function fetchDataSourceHandleInfo(organizationId) {
    return getDataSourceHandleInfo(organizationId, organizationSettingsConstants.GET_DATA_SOURCE_HANDLE_INFO_FETCH_REQUEST);
}

function fetchTrendsDataSourceHandles(organizationTrendsId) {
    return dispatch => {
        if (!organizationTrendsId) {
            return;
        }
        dispatch(getActionData(organizationSettingsConstants.GET_TRENDS_DATA_SOURCE_HANDLES_REQUEST));
        organizationSettingsService.getTrendsDataSourceHandles(organizationTrendsId)
            .then((response) => {
                dispatch(getActionData(organizationSettingsConstants.GET_TRENDS_DATA_SOURCE_HANDLES_SUCCESS, response.data));
            }).catch((error) => {
            if (_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(organizationSettingsConstants.GET_TRENDS_DATA_SOURCE_HANDLES_FAILURE, {}, error));
        });
    };
}

function fetchTrendsOrganization(organizationTrendsId) {
    return dispatch => {
        if (!organizationTrendsId) {
            return;
        }
        dispatch(getActionData(organizationSettingsConstants.GET_TRENDS_ORGANIZATION_REQUEST));
        organizationSettingsService.getTrendsOrganization(organizationTrendsId)
            .then((response) => {
                dispatch(getActionData(organizationSettingsConstants.GET_TRENDS_ORGANIZATION_SUCCESS, response.data));
            }).catch((error) => {
            if (_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(organizationSettingsConstants.GET_TRENDS_ORGANIZATION_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        });
    };
}

function updateTrendsOrganizationSetting(organizationTrendsId, field, value) {
    return dispatch => {
        if (!organizationTrendsId || !field) {
            return;
        }
        dispatch(getActionData(organizationSettingsConstants.UPDATE_TRENDS_ORGANIZATION_SETTING_REQUEST, {field}));
        organizationSettingsService.updateTrendsOrganizationSetting(organizationTrendsId, {[field]: value})
            .then((response) => {
                dispatch(getActionData(organizationSettingsConstants.UPDATE_TRENDS_ORGANIZATION_SETTING_SUCCESS, response.data));
                SnackBar.showMessage(alertMessages.TRENDS_ORGANIZATION_SETTING_UPDATE_SUCCESS);
            }).catch((error) => {
            if (_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(organizationSettingsConstants.UPDATE_TRENDS_ORGANIZATION_SETTING_FAILURE, {}, error));
            SnackBar.showMessage(
                _.get(error, 'response.data.message') || alertMessages.TRENDS_ORGANIZATION_SETTING_UPDATE_FAILURE
            );
        });
    };
}

function getAutoActionsInfo(organizationId, requestType) {
    return dispatch => {
        dispatch(getActionData(requestType));
        organizationSettingsService.getAutoActionsInfo(organizationId)
            .then((response) => {
                const data = dataSourceHandleInfoResponseWithOrganizationId(response.data, organizationId);
                dispatch(getActionData(organizationSettingsConstants.GET_AUTO_ACTIONS_INFO_SUCCESS, data));
            }).catch((error) => {
            if (_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(organizationSettingsConstants.GET_AUTO_ACTIONS_INFO_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        });
    };
}

function fetchAutoActionsInfo(organizationId) {
    return getAutoActionsInfo(organizationId, organizationSettingsConstants.GET_AUTO_ACTIONS_INFO_FETCH_REQUEST);
}


function refreshAutoActionsInfo(organizationId) {
    return getAutoActionsInfo(organizationId, organizationSettingsConstants.GET_AUTO_ACTIONS_INFO_REFRESH_REQUEST);
}

function refreshDataSourceHandleInfo(organizationId) {
    return getDataSourceHandleInfo(organizationId, organizationSettingsConstants.GET_DATA_SOURCE_HANDLE_INFO_REFRESH_REQUEST);
}

function fetchOrganizationDisableProcesses(organizationId) {
    return dispatch => {
        dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_DISABLE_PROCESSES_REQUEST));
        organizationSettingsService.getOrganizationDisableProcesses(organizationId)
            .then((response) => {
                dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_DISABLE_PROCESSES_SUCCESS, response.data));
            }).catch((error) => {
            if (_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_DISABLE_PROCESSES_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        });
    }
}

function initiateDisableProcess(params) {
    return dispatch => {
        dispatch(getActionData(organizationSettingsConstants.INITIATE_ORGANIZATION_DISABLE_PROCESS_REQUEST));
        return organizationSettingsService.initiateDisableProcess(params)
            .then(() => {
                dispatch(getActionData(organizationSettingsConstants.INITIATE_ORGANIZATION_DISABLE_PROCESS_SUCCESS));
                SnackBar.showMessage(alertMessages.INITIATE_ORGANIZATION_DISABLE_PROCESS_SUCCESS);
            }).catch((error) => {
                if (_.get(error, 'response.status') === 401) {
                    Auth.processLogout();
                    return;
                }
                dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_DISABLE_PROCESSES_FAILURE, {}, error));
                SnackBar.showMessage(alertMessages.INITIATE_ORGANIZATION_DISABLE_PROCESS_FAILURE);
            });
    }
}

function fetchOrganizationRemoveProcesses(organizationId) {
    return dispatch => {
        dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_REMOVE_PROCESSES_REQUEST));
        organizationSettingsService.getOrganizationRemoveProcesses(organizationId)
            .then((response) => {
                dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_REMOVE_PROCESSES_SUCCESS, response.data));
            }).catch((error) => {
            if (_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_REMOVE_PROCESSES_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        });
    }
}

function initiateRemoveProcess(params) {
    return dispatch => {
        dispatch(getActionData(organizationSettingsConstants.INITIATE_ORGANIZATION_REMOVE_PROCESS_REQUEST));
        return organizationSettingsService.initiateRemoveProcess(params)
            .then(() => {
                dispatch(getActionData(organizationSettingsConstants.INITIATE_ORGANIZATION_REMOVE_PROCESS_SUCCESS));
                SnackBar.showMessage(alertMessages.INITIATE_ORGANIZATION_REMOVE_PROCESS_SUCCESS);
            }).catch((error) => {
                if (_.get(error, 'response.status') === 401) {
                    Auth.processLogout();
                    return;
                }
                dispatch(getActionData(organizationSettingsConstants.GET_ORGANIZATION_REMOVE_PROCESSES_FAILURE, {}, error));
                SnackBar.showMessage(error.response.data.message || alertMessages.INITIATE_ORGANIZATION_REMOVE_PROCESS_FAILURE);
            });
    }
}

export const organizationSettingsActions = {
    getOrganizationInfo,
    fetchDataSourceHandleInfo,
    fetchTrendsDataSourceHandles,
    fetchTrendsOrganization,
    updateTrendsOrganizationSetting,
    fetchAutoActionsInfo,
    refreshDataSourceHandleInfo,
    refreshAutoActionsInfo,
    getOrganizationCSMs,
    updateOrganizationAttribute,
    updateTicketBudget,
    fetchOrganizationDisableProcesses,
    initiateDisableProcess,
    fetchOrganizationRemoveProcesses,
    initiateRemoveProcess,
    deleteSchedule,
    getMsgDataSources,
    removeScheduleFromStore
}
